/**
 * @generated SignedSource<<74ea36572748afbf45a34c114f29c340>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedShopByModuleItemVariant_trendingCreator$data = {
  readonly category: string | null;
  readonly creator: {
    readonly browsePageLinkData: {
      readonly path: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"SeoLink_linkData">;
    };
    readonly displayName: string | null;
  } | null;
  readonly firstItemPhotoWebPath: string | null;
  readonly " $fragmentType": "HpSharedShopByModuleItemVariant_trendingCreator";
};
export type HpSharedShopByModuleItemVariant_trendingCreator$key = {
  readonly " $data"?: HpSharedShopByModuleItemVariant_trendingCreator$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedShopByModuleItemVariant_trendingCreator">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedShopByModuleItemVariant_trendingCreator",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "category",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Creator",
      "kind": "LinkedField",
      "name": "creator",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkData",
          "kind": "LinkedField",
          "name": "browsePageLinkData",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "path",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SeoLink_linkData"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "size",
          "value": "master"
        }
      ],
      "kind": "ScalarField",
      "name": "firstItemPhotoWebPath",
      "storageKey": "firstItemPhotoWebPath(size:\"master\")"
    }
  ],
  "type": "TrendingCreator",
  "abstractKey": null
};

(node as any).hash = "b6e5e5d23f2effcc1f0016c7e1422a10";

export default node;
